module.exports = __webpack_public_path__ + "static/grapeseed-5efb77fc9c41366b492e46769a9a7d0c.png";